import Vue from 'vue'
import Router from 'vue-router'
const Full = () => import('../components/full')
const Login = () => import('../views/login')
const page404 = () => import('../views/Error')

const Dashboard = () => import('../views/dashboard')
const Users = () => import('../views/users')
const Village = () => import('../views/villages')
const Zone = () => import('../views/zone')
const Incomehome = () => import('../views/incomehome')
const FormIncome = () => import('../views/formincome')
const FormUser = () => import('../views/formuser')
const Invoice = () => import('../views/invoice')
const InvoiceDetail = () => import('../views/invoice_detail')
const invoicePublic = () => import('../views/invoice_public')
const Receipt = () => import('../views/receipt')
const RegisLine = () => import('../views/regisline')
const Linenoti = () => import('../views/linenoti')
const Expenditure = () => import('../views/expenditure')
const ManageExpen = () => import('../views/manage_expen')
const ExpenDetail = () => import('../views/expen_detail')
const Setting = () => import('../views/setting')
const Advertise = () => import('../views/advertise')
const Outstanding = () => import('../views/outstanding')
const Reporthome = () => import('../views/reporthome')
const Reportincome = () => import('../views/reportincome')
const Reportexpend = () => import('../views/reportexpend')
const Reportcompare = () => import('../views/reportcompare')
const Reportoverdue = () => import('../views/reportoverdue')
const Reportreceivedetail = () => import('../views/receivedetail')
const Reportincomeusermonth = () => import('../views/reportincomeusermonth')
const Reportwater = () => import('../views/reportwater')
const Reportcancelreceive = () => import('../views/report_cancel_receive')
const Process = () => import('../views/process')
const InvoiceCreateByHome = () => import('../views/invoice_create_by_home')

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const titlename = ' | ระบบจัดการข้อมูลหมู่บ้าน'

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: '/',
  routes: [
    {
      path: '/',
      name: 'full',
      component: Full,
      children: [{
        path: '/',
        name: 'main',
        component: Dashboard,
        meta: { title: 'หน้าแรก', group_id: 8 }
      },
      {
        path: '/users',
        name: 'users',
        component: Users,
        meta: { title: 'จัดการข้อมูลผู้ใช้งาน', group_id: 1 }
      },
      {
        path: '/villages',
        name: 'villages',
        component: Village,
        meta: { title: 'จัดการข้อมูลทะเบียนบ้าน', group_id: 2 }
      },
      {
        path: '/zone',
        name: 'zone',
        component: Zone,
        meta: { title: 'จัดการข้อมูลโซนที่อยู่', group_id: 2 }
      },
      {
        path: '/incomehome',
        name: 'incomehome',
        component: Incomehome,
        meta: { title: 'บันทึกค่าใช้น้ำรายเดือน', group_id: 6 }
      },
      {
        path: '/formincome/:id',
        name: 'formincome',
        component: FormIncome,
        meta: { title: 'บันทึกค่าใช้น้ำรายเดือน', group_id: 6 }
      },
      {
        path: '/formuser',
        name: 'FormUser',
        component: FormUser,
        meta: { title: 'แก้ไขข้อมูลผู้ใช้งาน', group_id: 99 }
      },
      {
        path: '/invoice',
        name: 'Invoice',
        component: Invoice,
        meta: { title: 'ข้อมูลใบแจ้งหนี้รายเดือน', group_id: 3 }
      },
      {
        path: '/invoice_create_by_home',
        name: 'InvoiceCreateByHome',
        component: InvoiceCreateByHome,
        meta: { title: 'สร้างใบแจ้งหนี้ตามทะเบียนบ้าน', group_id: 3 }
      },
      {
        path: '/invoice/:key',
        name: 'InvoiceDetail',
        component: InvoiceDetail,
        meta: { title: 'ข้อมูลยละเอียดใบแจ้งหนี้รายเดือน', group_id: 3 }
      },
      {
        path: '/receipt',
        name: 'Receipt',
        component: Receipt,
        meta: { title: 'ใบเสร็จรับเงิน', group_id: 3 }
      },
      {
        path: '/expenditure',
        name: 'Expenditure',
        component: Expenditure,
        meta: { title: 'บันทึกข้อมูลรายจ่าย', group_id: 4 }
      },
      {
        path: '/expenditure/:id',
        name: 'EditExpenditure',
        component: Expenditure,
        meta: { title: 'แก้ไขข้อมูลรายจ่าย', group_id: 4 }
      },
      {
        path: '/manageexp',
        name: 'ManageExpen',
        component: ManageExpen,
        meta: { title: 'ข้อมูลรายจ่าย', group_id: 4 }
      },
      {
        path: '/manageexp/:id',
        name: 'expenddetail',
        component: ExpenDetail,
        meta: { title: 'ข้อมูลรายจ่าย', group_id: 4 }
      },
      {
        path: '/setting',
        name: 'setting',
        component: Setting,
        meta: { title: 'ตั้งค่าระบบ', group_id: 7 }
      },
      {
        path: '/advertise',
        name: 'Advertise',
        component: Advertise,
        meta: { title: 'แจ้งข่าวประชาสัมพันธ์', group_id: 7 }
      },
      {
        path: '/outstandingmonth',
        name: 'Outstanding',
        component: Outstanding,
        meta: { title: 'สรุปยอดคงค้างรายเดือน', group_id: 5 }
      },
      {
        path: '/reporthome',
        name: 'Reporthome',
        component: Reporthome,
        meta: { title: 'รายงานข้อมูลทะเบียนบ้าน', group_id: 5 }
      },
      {
        path: '/reportincomemonth',
        name: 'Reportincome',
        component: Reportincome,
        meta: { title: 'รายงานการรับชำระ', group_id: 5 }
      },
      {
        path: '/reportexpenmonth',
        name: 'Reportexpend',
        component: Reportexpend,
        meta: { title: 'สรุปรายจ่ายประจำเดือน', group_id: 5 }
      },
      {
        path: '/compareexpenmonth',
        name: 'Reportcompare',
        component: Reportcompare,
        meta: { title: 'สรุปรายรับรายจ่ายประจำเดือน', group_id: 5 }
      },
      {
        path: '/reportoverdue',
        name: 'Reportoverdue',
        component: Reportoverdue,
        meta: { title: 'รายงานค้างชำระแยกตามจำนวนเดือนค้างชำระ', group_id: 5 }
      },
      {
        path: '/reportreceivedetail',
        name: 'Reportreceivedetail',
        component: Reportreceivedetail,
        meta: { title: 'รายงานรายละเอียดการรับชำระประจำวัน', group_id: 5 }
      },
      {
        path: '/reportincomeusermonth',
        name: 'Reportincomeusermonth',
        component: Reportincomeusermonth,
        meta: { title: 'รายงานรับชำระแยกตามกลุ่มการชำระ', group_id: 5 }
      },
      {
        path: '/reportwater',
        name: 'Reportwater',
        component: Reportwater,
        meta: { title: 'รายงานค่าน้ำ', group_id: 5 }
      },
      {
        path: '/reportcancelreceive',
        name: 'Reportcancelreceive',
        component: Reportcancelreceive,
        meta: { title: 'รายงานยกเลิกใบเสร็จ', group_id: 5 }
      },
      {
        path: '/process',
        name: 'Process',
        component: Process,
        meta: { title: 'ประมวลผลระบบ', group_id: 7 }
      }
      ]
    },
    {
      path: '/invoice_public/:key',
      name: 'invoicePublic',
      component: invoicePublic,
      meta: { title: 'ข้อมูลยละเอียดใบแจ้งหนี้รายเดือน', group_id: 3 }
    },
    {
      path: '/regisline',
      name: 'RegisLine',
      component: RegisLine,
      meta: { title: 'ลงทะเบียนรับข้อมูลข่าวสารของหมู่บ้าน' }
    },
    {
      path: '/noti',
      name: 'noti',
      component: Linenoti,
      meta: { title: 'ลงทะเบียนรับข้อมูลข่าวสารของหมู่บ้าน' }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { title: 'เข้าสู่ระบบ' }
    },
    {
      path: '*',
      name: 'P404',
      component: page404,
      meta: { title: 'Error Page' }
    }
  ]
})

const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js